<template>
<nav>
        <v-toolbar color="primary" dark flat app>
            <v-toolbar-side-icon @click="drawer = ! drawer"></v-toolbar-side-icon>
            <v-toolbar-title class="text-uppercase" color="white">
                <span class="font-weight-light">General</span>
                <span>Valor</span>
            </v-toolbar-title>


            <v-spacer></v-spacer>

            <!-- v-btn icon>
                <v-icon>search</v-icon>
            </v-btn -->
            <v-spacer></v-spacer>
            <span class="text-uppercase">{{$session.get('user').first_name +" "+ $session.get('user').last_name}}</span>
        </v-toolbar>
        <v-navigation-drawer class="grey lighten-4" v-model="drawer" app temporary>
            <v-list>
                <v-list-tile v-for="link in links" :key="link.text" router :to="link.route">
                    <v-list-tile-action>
                        <v-icon>{{link.icon}}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title class="text-uppercase">{{ link.text }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
</nav>
</template>

<script>
export default {
    
    data() {
        return {
            drawer:false,
            links:[
                {icon: 'dashboard', text: 'Tableau de bord', route:'/'},
                //{icon: 'supervisor_account', text: 'Administration', route:'/admin'},
                //{icon: 'calendar_today', text: 'Agenda', route:'/agenda'},
                //{icon :'email', text: 'Boite Mail', route:'/mail'},
                {icon: 'home', text: 'Mandats', route: '/mandats'},
                {icon: 'bookmark', text: 'Estimations', route:'/estim'},
                {icon: 'archive', text: 'Archives', route:'/archives'},
                {icon: 'person', text: 'Clients', route:'/clients'}
                                
            ]
        }
    }
}
</script>
    